import { render, staticRenderFns } from "./BusinessOfficesIcon.vue?vue&type=template&id=05b2310e&"
import script from "./BusinessOfficesIcon.vue?vue&type=script&lang=js&"
export * from "./BusinessOfficesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports